module.exports = __webpack_public_path__ + "img/churchpluswhiteLogo.3364b592.png";